import React from 'react';
import styled from 'styled-components';
import { useGoogleFonts } from '@flyyer/use-googlefonts';

import Types from '../modules/types';

export const FontLoader = () => {
  const fonts = Types.FONT_PAIRINGS_ITEMS;

  const fontFamilies = fonts.reduce((acc, font) => {
    ['title', 'label', 'body'].forEach(category => {
      const family = font.fonts[category].family.replace(/\+/g, ' ');
      const variantNormal = font.fonts[category].variantNormal.toString();
      const variantBold = font.fonts[category].variantBold.toString();

      if (!acc[family]) {
        acc[family] = new Set();
      }
      acc[family].add(variantNormal);
      acc[family].add(variantBold);
    });
    return acc;
  }, {});

  const formattedFontFamilies = Object
    .entries(fontFamilies)
    .map(([family, variants]) => ({
      family,
      styles: Array.from(variants),
    })
    );

  useGoogleFonts(formattedFontFamilies);
  return null;
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Title = styled.div`
  font-size: ${({ font }) => font.scaling * 36}px;
  font-weight: ${({ font }) => font.variantNormal};
  font-family: ${({ font }) => `'${font.family.replace(/\+/g, ' ')}'`};
  letter-spacing: ${({ font }) => font.letterSpacing};
  text-transform: ${({ font }) => font.textTransform};

  font-weight: ${({ font }) => font.variantBold};
  strong {
    font-weight: ${({ font }) => font.variantBold};
  }

  line-height: 1;
`;

const Label = styled.div`
  font-size: ${({ font }) => font.scaling * 14}px;
  font-weight: ${({ font }) => font.variantNormal};
  font-family: ${({ font }) => `'${font.family.replace(/\+/g, ' ')}'`};
  letter-spacing: ${({ font }) => font.letterSpacing};
  text-transform: ${({ font }) => font.textTransform};

  strong {
    font-weight: ${({ font }) => font.variantBold};
  }
  
  margin: 5px auto 15px;
`;

const Body = styled.div`
  font-size: ${({ font }) => font.scaling * 16}px;
  font-weight: ${({ font }) => font.variantNormal};
  font-family: ${({ font }) => `'${font.family.replace(/\+/g, ' ')}'`};
  letter-spacing: ${({ font }) => font.letterSpacing};
  text-transform: ${({ font }) => font.textTransform};

  strong {
    font-weight: ${({ font }) => font.variantBold};
  }

  line-height: 1.2;
`;

const FontPreview = ({ fonts, title, subtitle }) => (
  <Wrapper>
    <Title
      font={fonts.title}
      dangerouslySetInnerHTML={{ __html: title }}
    />
    <Label
      font={fonts.label}
      dangerouslySetInnerHTML={{ __html: subtitle }}
    />
    <Body font={fonts.body}>
      A quick brown fox
      {' '}
      <strong>
        jumps over
        the lazy dog
      </strong>
      {' '}
      on a summer day.
    </Body>
  </Wrapper>
);

export default FontPreview;
